import script from "./ODSelection.vue?vue&type=script&setup=true&lang=js"
export * from "./ODSelection.vue?vue&type=script&setup=true&lang=js"

import "./ODSelection.vue?vue&type=style&index=0&id=54bf82a5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54bf82a5"]])

export default __exports__